// The header pill arrives with the scroll, not at a line in it.
//
// A class toggle was the first attempt and it always looked abrupt, because the
// trigger is binary however long you make the transition: the material has to
// travel its whole distance in a fixed time regardless of how fast or slow the
// reader is moving. Tying it to scroll position instead means the pill arrives
// exactly as quickly as the person scrolls, which is the difference between an
// animation playing at you and a material responding to you.
//
// The curve is smoothstep rather than linear, so it leaves and arrives softly
// instead of starting and stopping at full rate.

const header = document.querySelector('header-component.header')

if (header) {
  // Fully arrived by the time the opening line has cleared the viewport.
  const TRAVEL = 160
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  let ticking = false
  let last = -1

  // Where the header's own journey starts. Zero on most pages. On the
  // homepage the phone intro sits above the header, so the header only
  // reaches the top once the intro has scrolled away, and the pill should
  // arrive from THAT point, not from the top of the page. Measured rather than
  // assumed because the intro's length is a merchant setting.
  const intro = document.getElementById('intro-group')
  let origin = 0
  const measureOrigin = () => {
    origin = intro ? Math.round(intro.getBoundingClientRect().bottom + window.scrollY) : 0
  }
  measureOrigin()

  const smoothstep = (t) => t * t * (3 - 2 * t)

  const apply = () => {
    ticking = false
    const raw = Math.min(Math.max((window.scrollY - origin) / TRAVEL, 0), 1)
    const lift = reduced ? (raw > 0 ? 1 : 0) : smoothstep(raw)

    // Only touch the DOM when the value actually changes at the precision the
    // eye can see. Saves a style recalculation on most frames of a long scroll.
    const rounded = Math.round(lift * 100) / 100
    if (rounded === last) return
    last = rounded
    header.style.setProperty('--header-lift', String(rounded))
  }

  const onScroll = () => {
    if (ticking) return
    ticking = true
    requestAnimationFrame(apply)
  }

  {
    // The mobile menu drops out from under the header rather than covering it,
    // which means it needs to know where the header ends. Measured rather than
    // assumed, because the pill's height depends on the control size, its
    // padding and the page margin, and any of those can change in the editor.
    const publishStack = () => {
      const group = document.getElementById('header-group') || header
      const bottom = group.getBoundingClientRect().bottom + window.scrollY
      document.documentElement.style.setProperty('--header-stack', `${Math.round(bottom)}px`)
    }

    publishStack()
    window.addEventListener('resize', publishStack, { passive: true })
    // The pill's own arrival does not change its box, but a font swap or a
    // late-loading logo can, so re-measure once everything has settled.
    if (document.fonts?.ready) document.fonts.ready.then(publishStack)
  }

  apply()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener(
    'resize',
    () => {
      measureOrigin()
      onScroll()
    },
    { passive: true }
  )
}
